// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminUsageCost.css — Dark Data Dashboard Theme */

/* Period Selector */
.admin-period {
  display: flex;
  gap: 4px;
  background: var(--admin-surface);
  padding: 3px;
  border-radius: var(--radius-md);
  align-items: center;
  border: 1px solid var(--admin-border);
}

.admin-period__b {
  padding: 6px 14px;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}

.admin-period__b:hover {
  color: var(--admin-text-primary);
}

.admin-period__b--a {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
  box-shadow: none;
}

/* Date Range Picker */
.admin-date-range-sep {
  width: 1px;
  height: 16px;
  background: var(--admin-border);
  margin: 0 2px;
}

.admin-date-range-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.admin-date-range-trigger {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}

.admin-date-range-trigger:hover {
  color: var(--admin-text-primary);
}

.admin-date-range-trigger--a {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
  box-shadow: none;
}

.admin-date-range-trigger svg {
  width: 14px;
  height: 14px;
  stroke: currentColor;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.admin-date-range-display {
  font-size: 11px;
  color: #a78bfa;
  font-weight: 500;
  margin-left: 4px;
  padding: 3px 8px;
  background: rgba(167, 139, 250, 0.12);
  border-radius: var(--radius-full);
  white-space: nowrap;
}

.admin-date-range-panel {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
  z-index: 100;
  padding: 16px;
  display: none;
  min-width: 320px;
}

.admin-date-range-panel--open {
  display: block;
}

.admin-date-range-panel__title {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-bright);
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-date-range-panel__row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.admin-date-range-panel__label {
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  min-width: 40px;
}

.admin-date-range-panel__input {
  flex: 1 1;
  padding: 7px 10px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 12px;
  font-family: inherit;
  color: var(--admin-text-primary);
  background: var(--admin-bg);
  outline: none;
  transition: border-color 0.15s;
}

.admin-date-range-panel__input:focus {
  border-color: #a78bfa;
}

.admin-date-range-panel__presets {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-date-range-panel__preset {
  padding: 4px 10px;
  border: 1px solid var(--admin-border);
  background: var(--admin-bg);
  border-radius: var(--radius-full);
  font-size: 11px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}

.admin-date-range-panel__preset:hover {
  border-color: #a78bfa;
  color: #a78bfa;
}

.admin-date-range-panel__preset--a {
  background: rgba(167, 139, 250, 0.12);
  border-color: #a78bfa;
  color: #a78bfa;
}

.admin-date-range-panel__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.admin-date-range-panel__btn {
  padding: 6px 14px;
  border-radius: var(--radius-md);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  border: none;
}

.admin-date-range-panel__btn--cancel {
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  color: var(--admin-text-secondary);
}

.admin-date-range-panel__btn--cancel:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
}

.admin-date-range-panel__btn--apply {
  background: linear-gradient(135deg, #7c3aed, #6d28d9);
  color: #fff;
}

.admin-date-range-panel__btn--apply:hover {
  box-shadow: 0 4px 16px rgba(124, 58, 237, 0.3);
}

/* Stat Cards */
.admin-stat-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-bottom: 24px;
}

.admin-stat-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  padding: 16px;
  position: relative;
  overflow: hidden;
}

.admin-stat-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.admin-stat-card__icon {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-stat-card__icon--visit { background: rgba(139, 92, 246, 0.12); color: #8b5cf6; }
.admin-stat-card__icon--user { background: rgba(6, 182, 212, 0.12); color: #06b6d4; }
.admin-stat-card__icon--member { background: rgba(34, 197, 94, 0.12); color: #22c55e; }
.admin-stat-card__icon--total { background: rgba(167, 139, 250, 0.12); color: #a78bfa; }
.admin-stat-card__icon--api { background: rgba(59, 130, 246, 0.12); color: #3b82f6; }
.admin-stat-card__icon--mcp { background: var(--admin-info-bg); color: var(--admin-info); }

.admin-stat-card__trend {
  font-size: 10px;
  font-weight: 600;
}

.admin-stat-card__trend--up { color: var(--admin-success); }
.admin-stat-card__trend--neutral { color: var(--admin-info); }

.admin-stat-card__label {
  font-size: 11px;
  color: var(--admin-text-muted);
  margin-bottom: 2px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.admin-stat-card__value {
  font-size: 28px;
  font-weight: 800;
  color: var(--admin-text-bright);
}

.admin-stat-card__sub {
  font-size: 10px;
  color: var(--admin-text-muted);
  margin-top: 3px;
}

/* Charts */
.admin-chart-row {
  display: grid;
  grid-template-columns: 5fr 3fr;
  gap: 16px;
  margin-bottom: 24px;
}

.admin-chart-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  overflow: visible;
  position: relative;
}

.admin-chart-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-chart-card__title {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--admin-text-bright);
}

.admin-chart-card__body {
  padding: 16px 20px;
  overflow: visible;
}

/* Line Chart */
.admin-line-chart {
  position: relative;
  height: 220px;
}

.admin-lc__svg {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.admin-lc__grid {
  stroke: var(--admin-border);
  stroke-width: 1;
}

.admin-lc__line {
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.admin-lc__area {
  opacity: 0.08;
}

.admin-lc__area--stacked {
  opacity: 0.78;
}

.admin-lc__total-dot {
  fill: var(--admin-surface, #fff);
  stroke: var(--admin-text-secondary, #64748b);
  stroke-width: 1.2;
  pointer-events: none;
}

.admin-lc__dot {
  r: 4;
  stroke-width: 2;
  stroke: var(--admin-surface);
  cursor: pointer;
  transition: r 0.15s;
}

.admin-lc__dot:hover {
  r: 6;
}

.admin-lc__label {
  font-size: 10px;
  fill: var(--admin-text-muted);
  text-anchor: middle;
}

.admin-lc__vlabel {
  font-size: 9px;
  fill: var(--admin-text-muted);
  text-anchor: end;
}

.admin-chart-legend {
  display: flex;
  gap: 12px;
  margin-top: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.admin-chart-legend__item {
  font-size: 10px;
  color: var(--admin-text-secondary);
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
}

.admin-chart-legend__color {
  width: 8px;
  height: 3px;
  border-radius: 2px;
}

/* Provider Cost List */
.admin-provider-cost-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.admin-provider-cost-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px;
  border-radius: var(--radius-md);
  transition: background 0.15s;
}

.admin-provider-cost-item:hover {
  background: var(--admin-surface-hover);
}

.admin-provider-cost-item__logo {
  width: 28px;
  height: 28px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
}

.admin-provider-cost-item__info {
  flex: 1 1;
}

.admin-provider-cost-item__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
}

.admin-provider-cost-item__name {
  font-size: 12px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-provider-cost-item__amount {
  font-size: 12px;
  font-weight: 700;
  color: var(--admin-text-bright);
}

.admin-provider-cost-item__bar {
  height: 5px;
  background: var(--admin-bg);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.admin-provider-cost-item__fill {
  height: 100%;
  border-radius: var(--radius-full);
}

.admin-provider-cost-item__meta {
  margin-top: 3px;
  font-size: 10px;
  color: var(--admin-text-muted);
}

/* Section */
.admin-usage-section {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  margin-bottom: 20px;
}

.admin-usage-section:last-child {
  margin-bottom: 0;
}

.admin-usage-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid var(--admin-border);
  background: var(--admin-surface);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.15s;
}

.admin-usage-section__header:hover {
  background: var(--admin-surface-hover);
}

.admin-usage-section__header--collapsed {
  border-bottom: none;
}

.admin-usage-section__left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-usage-section__toggle {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-text-muted);
  transition: transform 0.2s;
}

.admin-usage-section__toggle--collapsed {
  transform: rotate(-90deg);
}

.admin-usage-section__title {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--admin-text-bright);
}

.admin-usage-section__count {
  font-size: 11px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  background: var(--admin-surface-hover);
  padding: 2px 8px;
  border-radius: var(--radius-full);
}

.admin-usage-section__actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.admin-usage-section__body {
  transition: all 0.2s ease;
}

/* View Toggle Group */
.admin-view-toggle-group {
  display: flex;
  gap: 2px;
  background: var(--admin-bg);
  padding: 3px;
  border-radius: var(--radius-md);
  border: 1px solid var(--admin-border);
}

.admin-view-toggle-group__btn {
  padding: 5px 12px;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}

.admin-view-toggle-group__btn--active {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
  box-shadow: none;
}

/* Filter Bar */
.admin-filter-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--admin-border);
  flex-wrap: wrap;
}

.admin-filter-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-secondary);
}

.admin-filter-select {
  padding: 5px 10px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 12px;
  background: var(--admin-bg);
  cursor: pointer;
  color: var(--admin-text-primary);
}

.admin-filter-select:focus {
  outline: none;
  border-color: #a78bfa;
}

.admin-filter-query {
  padding: 5px 10px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 12px;
  background: var(--admin-bg);
  min-width: 140px;
  color: var(--admin-text-primary);
}

.admin-filter-query:focus {
  outline: none;
  border-color: #a78bfa;
}

/* Data Table */
.admin-data-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--admin-surface);
}

.admin-data-table th {
  text-align: left;
  padding: 9px 12px;
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: var(--admin-surface);
  border-bottom: 1px solid var(--admin-border);
  white-space: nowrap;
}

.admin-data-table th.r,
.admin-data-table td.r {
  text-align: right;
}

.admin-data-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--admin-border-light);
  font-size: 13px;
  vertical-align: middle;
  color: var(--admin-text-primary);
}

.admin-data-table tbody tr {
  transition: background 0.15s;
  cursor: pointer;
}

.admin-data-table tbody tr:hover {
  background: var(--admin-surface-hover);
}

.admin-data-table tbody tr:last-child td {
  border-bottom: none;
}

.admin-data-table tfoot td {
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;
  background: var(--admin-bg);
  border-top: 2px solid var(--admin-border);
  color: var(--admin-text-bright);
}

/* Table Cells */
.admin-cell-provider {
  display: flex;
  align-items: center;
  gap: 7px;
}

.admin-cell-provider__logo {
  width: 22px;
  height: 22px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  flex-shrink: 0;
}

.admin-cell-model {
  display: flex;
  flex-direction: column;
}

.admin-cell-model__name {
  font-weight: 600;
  font-size: 13px;
  color: var(--admin-text-bright);
}

.admin-cell-model__id {
  font-size: 10px;
  color: var(--admin-text-muted);
  font-family: monospace;
}

.admin-cell-instructor {
  display: flex;
  align-items: center;
  gap: 7px;
}

.admin-cell-instructor__avatar {
  width: 26px;
  height: 26px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  flex-shrink: 0;
}

.admin-cell-expand {
  color: var(--admin-text-muted);
  transition: transform 0.2s;
}

.admin-cell-expand--open {
  transform: rotate(90deg);
}

.admin-cost-cell {
  font-weight: 700;
  font-size: 13px;
  white-space: nowrap;
  color: var(--admin-text-bright);
}

.admin-unit-label {
  font-size: 10px;
  color: var(--admin-text-muted);
  font-weight: 400;
  margin-left: 2px;
}

.admin-progress-bar {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.admin-progress-bar__track {
  width: 44px;
  height: 5px;
  background: var(--admin-bg);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.admin-progress-bar__fill {
  height: 100%;
  border-radius: var(--radius-full);
}

/* Caps Wrap */
.admin-caps-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}

.admin-class-status {
  font-size: 10px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: var(--radius-full);
}

.admin-class-status--active {
  background: rgba(34, 197, 94, 0.12);
  color: var(--admin-success);
}

.admin-class-status--ended {
  background: var(--admin-surface-hover);
  color: var(--admin-text-muted);
}

/* MCP Tool */
.admin-mcp-tool {
  display: flex;
  align-items: center;
  gap: 7px;
}

.admin-mcp-tool__icon {
  width: 26px;
  height: 26px;
  border-radius: var(--radius-md);
  background: var(--admin-info-bg);
  color: var(--admin-info);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.admin-mcp-tool__info {
  display: flex;
  flex-direction: column;
}

.admin-mcp-tool__name {
  font-weight: 600;
  font-size: 13px;
  color: var(--admin-text-bright);
}

.admin-mcp-tool__desc {
  font-size: 10px;
  color: var(--admin-text-muted);
}

/* Table Footer */
.admin-table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-top: 1px solid var(--admin-border);
  background: var(--admin-bg);
}

.admin-table-info {
  font-size: 12px;
  color: var(--admin-text-muted);
}

/* Usage Detail */
.admin-usage-detail-title {
  font-size: 13px;
  font-weight: 600;
  margin: 14px 0 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--admin-text-bright);
}

.admin-usage-detail-title:first-child {
  margin-top: 0;
}

.admin-usage-detail-grid {
  display: grid;
  grid-template-columns: 110px 1fr;
  margin-bottom: 14px;
}

.admin-usage-detail-grid dt {
  font-size: 12px;
  font-weight: 600;
  color: var(--admin-text-muted);
  padding: 6px 0;
  border-bottom: 1px solid var(--admin-border);
}

.admin-usage-detail-grid dd {
  font-size: 13px;
  padding: 6px 0;
  border-bottom: 1px solid var(--admin-border);
  color: var(--admin-text-primary);
}

.admin-usage-detail-grid dt:last-of-type,
.admin-usage-detail-grid dd:last-child {
  border-bottom: none;
}

/* Buttons (AdminUsageCost variant only, base .admin-btn in AdminCommon.css) */
.admin-btn--s {
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  color: var(--admin-text-primary);
}

.admin-btn--s:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-bright);
}

/* Chart Tooltip */
.admin-chart-tooltip {
  position: absolute;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  color: var(--admin-text-primary);
  padding: 10px 14px;
  border-radius: var(--radius-md);
  font-size: 12px;
  pointer-events: none;
  z-index: 10;
  white-space: nowrap;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
  line-height: 1.6;
}

.admin-chart-tooltip__header {
  font-weight: 600;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--admin-border);
  padding-bottom: 4px;
  color: var(--admin-text-bright);
}

.admin-chart-tooltip__row {
  display: flex;
  align-items: center;
  gap: 5px;
}

.admin-chart-tooltip__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.admin-chart-tooltip__name {
  min-width: 70px;
  color: var(--admin-text-secondary);
}

/* Model Usage Summary Banner */
.admin-model-usage-banner {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 10px 20px;
  background: rgba(124, 58, 237, 0.06);
  border-bottom: 1px solid var(--admin-border);
  flex-wrap: wrap;
}

.admin-model-usage-banner__item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-model-usage-banner__label {
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.admin-model-usage-banner__value {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-model-usage-banner__value--cost {
  color: #a78bfa;
}

/* Instructor table inactive row */
.admin-data-table tbody tr.admin-row--inactive {
  opacity: 0.5;
  filter: grayscale(0.6);
}

/* Usage page modal override */
.admin-usage-modal {
  max-width: 620px;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
}

/* ===== Usage Record Cards ===== */
.admin-usage-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 20px;
}

.admin-usage-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}

.admin-usage-card:hover {
  border-color: var(--admin-text-dim, #555);
  background: var(--admin-surface-hover);
}

.admin-usage-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.admin-usage-card__provider {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.admin-usage-card__provider-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.admin-usage-card__provider-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-bright);
}

.admin-usage-card__endpoint {
  font-size: 11px;
  color: var(--admin-text-muted);
  font-family: monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.admin-usage-card__time {
  font-size: 11px;
  color: var(--admin-text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

.admin-usage-card__body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.admin-usage-card__stats {
  display: flex;
  gap: 20px;
}

.admin-usage-card__stat {
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-usage-card__stat-label {
  font-size: 11px;
  color: var(--admin-text-muted);
  font-weight: 500;
}

.admin-usage-card__stat-value {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
  font-variant-numeric: tabular-nums;
}

.admin-usage-card__status {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}

.admin-usage-card__status--success {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-usage-card__status--error {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

/* ── Ranking Card (Top 모델 / Top 사용자 공용) ── */
.admin-ranking-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md, 10px);
  margin-bottom: 16px;
  overflow: hidden;
}

.admin-ranking-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid var(--admin-border);
  gap: 12px;
  flex-wrap: wrap;
}

.admin-ranking-card__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--admin-text-primary);
  margin: 0;
}

.admin-ranking-card__tabs {
  display: inline-flex;
  background: var(--admin-surface-muted, var(--admin-surface-hover));
  border-radius: var(--radius-sm, 6px);
  padding: 2px;
  gap: 2px;
}

.admin-ranking-card__tab {
  border: none;
  background: transparent;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  border-radius: var(--radius-sm, 4px);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.admin-ranking-card__tab:hover {
  color: var(--admin-text-primary);
}

.admin-ranking-card__tab--active {
  background: var(--admin-surface);
  color: var(--primary-600, var(--admin-text-primary));
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.admin-ranking-card__period {
  display: inline-flex;
  gap: 4px;
}

.admin-ranking-card__period-btn {
  border: 1px solid var(--admin-border);
  background: var(--admin-surface);
  padding: 4px 10px;
  font-size: 11px;
  color: var(--admin-text-secondary);
  border-radius: var(--radius-sm, 4px);
  cursor: pointer;
}

.admin-ranking-card__period-btn--active {
  background: var(--primary-50, var(--admin-surface-hover));
  border-color: var(--primary-500, var(--admin-border));
  color: var(--primary-700, var(--admin-text-primary));
}

.admin-ranking-card__body {
  padding: 8px 12px 12px;
}

.admin-ranking-card__empty {
  padding: 32px;
  text-align: center;
  color: var(--text-tertiary, var(--admin-text-secondary));
  font-size: 13px;
}

.admin-ranking-card__note {
  padding: 8px 18px 10px;
  font-size: 11px;
  color: var(--admin-text-muted, var(--admin-text-secondary));
}

.admin-ranking-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.admin-ranking-list__item {
  display: grid;
  grid-template-columns: 28px 28px minmax(140px, 1.6fr) minmax(120px, 2fr) 96px;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: var(--radius-sm, 6px);
  cursor: pointer;
  transition: background 0.12s;
}

.admin-ranking-list__item:hover {
  background: var(--admin-surface-hover);
}

.admin-ranking-list__rank {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  color: var(--admin-text-secondary);
  background: var(--admin-surface-hover);
}

.admin-ranking-list__rank--top {
  background: linear-gradient(135deg, #fde68a 0%, #f59e0b 100%);
  color: #78350f;
}

.admin-ranking-list__logo {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-ranking-list__avatar {
  background: linear-gradient(135deg, var(--primary-400, #8b5cf6) 0%, var(--primary-600, #6d28d9) 100%);
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
}

.admin-ranking-list__info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.admin-ranking-list__name {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-ranking-list__sub {
  font-size: 11px;
  color: var(--admin-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-ranking-list__bar {
  position: relative;
  height: 6px;
  background: var(--admin-surface-hover);
  border-radius: 999px;
  overflow: hidden;
  min-width: 80px;
}

.admin-ranking-list__bar-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 999px;
  background: var(--primary-500, #8b5cf6);
  transition: width 0.25s ease;
}

.admin-ranking-list__value {
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

`, "",{"version":3,"sources":["webpack://./src/css/AdminUsageCost.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,2BAA2B;EAC3B,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gCAAgC,oCAAoC,EAAE,cAAc,EAAE;AACtF,+BAA+B,mCAAmC,EAAE,cAAc,EAAE;AACpF,iCAAiC,mCAAmC,EAAE,cAAc,EAAE;AACtF,gCAAgC,qCAAqC,EAAE,cAAc,EAAE;AACvF,8BAA8B,oCAAoC,EAAE,cAAc,EAAE;AACpF,8BAA8B,gCAAgC,EAAE,wBAAwB,EAAE;;AAE1F;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B,2BAA2B,EAAE;AAC3D,mCAAmC,wBAAwB,EAAE;;AAE7D;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,IAAI;EACJ,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,IAAI;AACN;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;EAChC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sCAAsC;EACtC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;EACf,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,kEAAkE;EAClE,oCAAoC;EACpC,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oCAAoC;EACpC,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,oDAAoD;EACpD,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,yDAAyD;EACzD,qDAAqD;EACrD,oDAAoD;AACtD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wDAAwD;EACxD,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,6EAA6E;EAC7E,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qGAAqG;EACrG,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC","sourcesContent":["/* AdminUsageCost.css — Dark Data Dashboard Theme */\n\n/* Period Selector */\n.admin-period {\n  display: flex;\n  gap: 4px;\n  background: var(--admin-surface);\n  padding: 3px;\n  border-radius: var(--radius-md);\n  align-items: center;\n  border: 1px solid var(--admin-border);\n}\n\n.admin-period__b {\n  padding: 6px 14px;\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s;\n}\n\n.admin-period__b:hover {\n  color: var(--admin-text-primary);\n}\n\n.admin-period__b--a {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n  box-shadow: none;\n}\n\n/* Date Range Picker */\n.admin-date-range-sep {\n  width: 1px;\n  height: 16px;\n  background: var(--admin-border);\n  margin: 0 2px;\n}\n\n.admin-date-range-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.admin-date-range-trigger {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s;\n}\n\n.admin-date-range-trigger:hover {\n  color: var(--admin-text-primary);\n}\n\n.admin-date-range-trigger--a {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n  box-shadow: none;\n}\n\n.admin-date-range-trigger svg {\n  width: 14px;\n  height: 14px;\n  stroke: currentColor;\n  stroke-width: 2;\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.admin-date-range-display {\n  font-size: 11px;\n  color: #a78bfa;\n  font-weight: 500;\n  margin-left: 4px;\n  padding: 3px 8px;\n  background: rgba(167, 139, 250, 0.12);\n  border-radius: var(--radius-full);\n  white-space: nowrap;\n}\n\n.admin-date-range-panel {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);\n  z-index: 100;\n  padding: 16px;\n  display: none;\n  min-width: 320px;\n}\n\n.admin-date-range-panel--open {\n  display: block;\n}\n\n.admin-date-range-panel__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-bright);\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-date-range-panel__row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.admin-date-range-panel__label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  min-width: 40px;\n}\n\n.admin-date-range-panel__input {\n  flex: 1;\n  padding: 7px 10px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  font-family: inherit;\n  color: var(--admin-text-primary);\n  background: var(--admin-bg);\n  outline: none;\n  transition: border-color 0.15s;\n}\n\n.admin-date-range-panel__input:focus {\n  border-color: #a78bfa;\n}\n\n.admin-date-range-panel__presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 14px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-date-range-panel__preset {\n  padding: 4px 10px;\n  border: 1px solid var(--admin-border);\n  background: var(--admin-bg);\n  border-radius: var(--radius-full);\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.admin-date-range-panel__preset:hover {\n  border-color: #a78bfa;\n  color: #a78bfa;\n}\n\n.admin-date-range-panel__preset--a {\n  background: rgba(167, 139, 250, 0.12);\n  border-color: #a78bfa;\n  color: #a78bfa;\n}\n\n.admin-date-range-panel__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.admin-date-range-panel__btn {\n  padding: 6px 14px;\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  border: none;\n}\n\n.admin-date-range-panel__btn--cancel {\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  color: var(--admin-text-secondary);\n}\n\n.admin-date-range-panel__btn--cancel:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n}\n\n.admin-date-range-panel__btn--apply {\n  background: linear-gradient(135deg, #7c3aed, #6d28d9);\n  color: #fff;\n}\n\n.admin-date-range-panel__btn--apply:hover {\n  box-shadow: 0 4px 16px rgba(124, 58, 237, 0.3);\n}\n\n/* Stat Cards */\n.admin-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n  margin-bottom: 24px;\n}\n\n.admin-stat-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  padding: 16px;\n  position: relative;\n  overflow: hidden;\n}\n\n.admin-stat-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.admin-stat-card__icon {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-stat-card__icon--visit { background: rgba(139, 92, 246, 0.12); color: #8b5cf6; }\n.admin-stat-card__icon--user { background: rgba(6, 182, 212, 0.12); color: #06b6d4; }\n.admin-stat-card__icon--member { background: rgba(34, 197, 94, 0.12); color: #22c55e; }\n.admin-stat-card__icon--total { background: rgba(167, 139, 250, 0.12); color: #a78bfa; }\n.admin-stat-card__icon--api { background: rgba(59, 130, 246, 0.12); color: #3b82f6; }\n.admin-stat-card__icon--mcp { background: var(--admin-info-bg); color: var(--admin-info); }\n\n.admin-stat-card__trend {\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.admin-stat-card__trend--up { color: var(--admin-success); }\n.admin-stat-card__trend--neutral { color: var(--admin-info); }\n\n.admin-stat-card__label {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  margin-bottom: 2px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.admin-stat-card__value {\n  font-size: 28px;\n  font-weight: 800;\n  color: var(--admin-text-bright);\n}\n\n.admin-stat-card__sub {\n  font-size: 10px;\n  color: var(--admin-text-muted);\n  margin-top: 3px;\n}\n\n/* Charts */\n.admin-chart-row {\n  display: grid;\n  grid-template-columns: 5fr 3fr;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.admin-chart-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  overflow: visible;\n  position: relative;\n}\n\n.admin-chart-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-chart-card__title {\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--admin-text-bright);\n}\n\n.admin-chart-card__body {\n  padding: 16px 20px;\n  overflow: visible;\n}\n\n/* Line Chart */\n.admin-line-chart {\n  position: relative;\n  height: 220px;\n}\n\n.admin-lc__svg {\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n}\n\n.admin-lc__grid {\n  stroke: var(--admin-border);\n  stroke-width: 1;\n}\n\n.admin-lc__line {\n  fill: none;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.admin-lc__area {\n  opacity: 0.08;\n}\n\n.admin-lc__area--stacked {\n  opacity: 0.78;\n}\n\n.admin-lc__total-dot {\n  fill: var(--admin-surface, #fff);\n  stroke: var(--admin-text-secondary, #64748b);\n  stroke-width: 1.2;\n  pointer-events: none;\n}\n\n.admin-lc__dot {\n  r: 4;\n  stroke-width: 2;\n  stroke: var(--admin-surface);\n  cursor: pointer;\n  transition: r 0.15s;\n}\n\n.admin-lc__dot:hover {\n  r: 6;\n}\n\n.admin-lc__label {\n  font-size: 10px;\n  fill: var(--admin-text-muted);\n  text-anchor: middle;\n}\n\n.admin-lc__vlabel {\n  font-size: 9px;\n  fill: var(--admin-text-muted);\n  text-anchor: end;\n}\n\n.admin-chart-legend {\n  display: flex;\n  gap: 12px;\n  margin-top: 10px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.admin-chart-legend__item {\n  font-size: 10px;\n  color: var(--admin-text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  cursor: pointer;\n}\n\n.admin-chart-legend__color {\n  width: 8px;\n  height: 3px;\n  border-radius: 2px;\n}\n\n/* Provider Cost List */\n.admin-provider-cost-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.admin-provider-cost-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px;\n  border-radius: var(--radius-md);\n  transition: background 0.15s;\n}\n\n.admin-provider-cost-item:hover {\n  background: var(--admin-surface-hover);\n}\n\n.admin-provider-cost-item__logo {\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.admin-provider-cost-item__info {\n  flex: 1;\n}\n\n.admin-provider-cost-item__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 3px;\n}\n\n.admin-provider-cost-item__name {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-provider-cost-item__amount {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n}\n\n.admin-provider-cost-item__bar {\n  height: 5px;\n  background: var(--admin-bg);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.admin-provider-cost-item__fill {\n  height: 100%;\n  border-radius: var(--radius-full);\n}\n\n.admin-provider-cost-item__meta {\n  margin-top: 3px;\n  font-size: 10px;\n  color: var(--admin-text-muted);\n}\n\n/* Section */\n.admin-usage-section {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.admin-usage-section:last-child {\n  margin-bottom: 0;\n}\n\n.admin-usage-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.15s;\n}\n\n.admin-usage-section__header:hover {\n  background: var(--admin-surface-hover);\n}\n\n.admin-usage-section__header--collapsed {\n  border-bottom: none;\n}\n\n.admin-usage-section__left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.admin-usage-section__toggle {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-text-muted);\n  transition: transform 0.2s;\n}\n\n.admin-usage-section__toggle--collapsed {\n  transform: rotate(-90deg);\n}\n\n.admin-usage-section__title {\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--admin-text-bright);\n}\n\n.admin-usage-section__count {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  background: var(--admin-surface-hover);\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n}\n\n.admin-usage-section__actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.admin-usage-section__body {\n  transition: all 0.2s ease;\n}\n\n/* View Toggle Group */\n.admin-view-toggle-group {\n  display: flex;\n  gap: 2px;\n  background: var(--admin-bg);\n  padding: 3px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--admin-border);\n}\n\n.admin-view-toggle-group__btn {\n  padding: 5px 12px;\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.admin-view-toggle-group__btn--active {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n  box-shadow: none;\n}\n\n/* Filter Bar */\n.admin-filter-bar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 20px;\n  border-bottom: 1px solid var(--admin-border);\n  flex-wrap: wrap;\n}\n\n.admin-filter-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n}\n\n.admin-filter-select {\n  padding: 5px 10px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  background: var(--admin-bg);\n  cursor: pointer;\n  color: var(--admin-text-primary);\n}\n\n.admin-filter-select:focus {\n  outline: none;\n  border-color: #a78bfa;\n}\n\n.admin-filter-query {\n  padding: 5px 10px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  background: var(--admin-bg);\n  min-width: 140px;\n  color: var(--admin-text-primary);\n}\n\n.admin-filter-query:focus {\n  outline: none;\n  border-color: #a78bfa;\n}\n\n/* Data Table */\n.admin-data-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--admin-surface);\n}\n\n.admin-data-table th {\n  text-align: left;\n  padding: 9px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  background: var(--admin-surface);\n  border-bottom: 1px solid var(--admin-border);\n  white-space: nowrap;\n}\n\n.admin-data-table th.r,\n.admin-data-table td.r {\n  text-align: right;\n}\n\n.admin-data-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--admin-border-light);\n  font-size: 13px;\n  vertical-align: middle;\n  color: var(--admin-text-primary);\n}\n\n.admin-data-table tbody tr {\n  transition: background 0.15s;\n  cursor: pointer;\n}\n\n.admin-data-table tbody tr:hover {\n  background: var(--admin-surface-hover);\n}\n\n.admin-data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.admin-data-table tfoot td {\n  padding: 10px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  background: var(--admin-bg);\n  border-top: 2px solid var(--admin-border);\n  color: var(--admin-text-bright);\n}\n\n/* Table Cells */\n.admin-cell-provider {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.admin-cell-provider__logo {\n  width: 22px;\n  height: 22px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n.admin-cell-model {\n  display: flex;\n  flex-direction: column;\n}\n\n.admin-cell-model__name {\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--admin-text-bright);\n}\n\n.admin-cell-model__id {\n  font-size: 10px;\n  color: var(--admin-text-muted);\n  font-family: monospace;\n}\n\n.admin-cell-instructor {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.admin-cell-instructor__avatar {\n  width: 26px;\n  height: 26px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 600;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.admin-cell-expand {\n  color: var(--admin-text-muted);\n  transition: transform 0.2s;\n}\n\n.admin-cell-expand--open {\n  transform: rotate(90deg);\n}\n\n.admin-cost-cell {\n  font-weight: 700;\n  font-size: 13px;\n  white-space: nowrap;\n  color: var(--admin-text-bright);\n}\n\n.admin-unit-label {\n  font-size: 10px;\n  color: var(--admin-text-muted);\n  font-weight: 400;\n  margin-left: 2px;\n}\n\n.admin-progress-bar {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.admin-progress-bar__track {\n  width: 44px;\n  height: 5px;\n  background: var(--admin-bg);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.admin-progress-bar__fill {\n  height: 100%;\n  border-radius: var(--radius-full);\n}\n\n/* Caps Wrap */\n.admin-caps-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n}\n\n.admin-class-status {\n  font-size: 10px;\n  font-weight: 500;\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n}\n\n.admin-class-status--active {\n  background: rgba(34, 197, 94, 0.12);\n  color: var(--admin-success);\n}\n\n.admin-class-status--ended {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-muted);\n}\n\n/* MCP Tool */\n.admin-mcp-tool {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.admin-mcp-tool__icon {\n  width: 26px;\n  height: 26px;\n  border-radius: var(--radius-md);\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.admin-mcp-tool__info {\n  display: flex;\n  flex-direction: column;\n}\n\n.admin-mcp-tool__name {\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--admin-text-bright);\n}\n\n.admin-mcp-tool__desc {\n  font-size: 10px;\n  color: var(--admin-text-muted);\n}\n\n/* Table Footer */\n.admin-table-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  border-top: 1px solid var(--admin-border);\n  background: var(--admin-bg);\n}\n\n.admin-table-info {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n}\n\n/* Usage Detail */\n.admin-usage-detail-title {\n  font-size: 13px;\n  font-weight: 600;\n  margin: 14px 0 6px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--admin-text-bright);\n}\n\n.admin-usage-detail-title:first-child {\n  margin-top: 0;\n}\n\n.admin-usage-detail-grid {\n  display: grid;\n  grid-template-columns: 110px 1fr;\n  margin-bottom: 14px;\n}\n\n.admin-usage-detail-grid dt {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  padding: 6px 0;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-usage-detail-grid dd {\n  font-size: 13px;\n  padding: 6px 0;\n  border-bottom: 1px solid var(--admin-border);\n  color: var(--admin-text-primary);\n}\n\n.admin-usage-detail-grid dt:last-of-type,\n.admin-usage-detail-grid dd:last-child {\n  border-bottom: none;\n}\n\n/* Buttons (AdminUsageCost variant only, base .admin-btn in AdminCommon.css) */\n.admin-btn--s {\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  color: var(--admin-text-primary);\n}\n\n.admin-btn--s:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-bright);\n}\n\n/* Chart Tooltip */\n.admin-chart-tooltip {\n  position: absolute;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  color: var(--admin-text-primary);\n  padding: 10px 14px;\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  pointer-events: none;\n  z-index: 10;\n  white-space: nowrap;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);\n  line-height: 1.6;\n}\n\n.admin-chart-tooltip__header {\n  font-weight: 600;\n  margin-bottom: 4px;\n  border-bottom: 1px solid var(--admin-border);\n  padding-bottom: 4px;\n  color: var(--admin-text-bright);\n}\n\n.admin-chart-tooltip__row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.admin-chart-tooltip__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.admin-chart-tooltip__name {\n  min-width: 70px;\n  color: var(--admin-text-secondary);\n}\n\n/* Model Usage Summary Banner */\n.admin-model-usage-banner {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 10px 20px;\n  background: rgba(124, 58, 237, 0.06);\n  border-bottom: 1px solid var(--admin-border);\n  flex-wrap: wrap;\n}\n\n.admin-model-usage-banner__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-model-usage-banner__label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.admin-model-usage-banner__value {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-model-usage-banner__value--cost {\n  color: #a78bfa;\n}\n\n/* Instructor table inactive row */\n.admin-data-table tbody tr.admin-row--inactive {\n  opacity: 0.5;\n  filter: grayscale(0.6);\n}\n\n/* Usage page modal override */\n.admin-usage-modal {\n  max-width: 620px;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n}\n\n/* ===== Usage Record Cards ===== */\n.admin-usage-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px 20px;\n}\n\n.admin-usage-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px 16px;\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.admin-usage-card:hover {\n  border-color: var(--admin-text-dim, #555);\n  background: var(--admin-surface-hover);\n}\n\n.admin-usage-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.admin-usage-card__provider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.admin-usage-card__provider-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.admin-usage-card__provider-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-bright);\n}\n\n.admin-usage-card__endpoint {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  font-family: monospace;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 300px;\n}\n\n.admin-usage-card__time {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.admin-usage-card__body {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.admin-usage-card__stats {\n  display: flex;\n  gap: 20px;\n}\n\n.admin-usage-card__stat {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-usage-card__stat-label {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  font-weight: 500;\n}\n\n.admin-usage-card__stat-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-usage-card__status {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.admin-usage-card__status--success {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-usage-card__status--error {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n/* ── Ranking Card (Top 모델 / Top 사용자 공용) ── */\n.admin-ranking-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md, 10px);\n  margin-bottom: 16px;\n  overflow: hidden;\n}\n\n.admin-ranking-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--admin-border);\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.admin-ranking-card__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  margin: 0;\n}\n\n.admin-ranking-card__tabs {\n  display: inline-flex;\n  background: var(--admin-surface-muted, var(--admin-surface-hover));\n  border-radius: var(--radius-sm, 6px);\n  padding: 2px;\n  gap: 2px;\n}\n\n.admin-ranking-card__tab {\n  border: none;\n  background: transparent;\n  padding: 5px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  border-radius: var(--radius-sm, 4px);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.admin-ranking-card__tab:hover {\n  color: var(--admin-text-primary);\n}\n\n.admin-ranking-card__tab--active {\n  background: var(--admin-surface);\n  color: var(--primary-600, var(--admin-text-primary));\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.admin-ranking-card__period {\n  display: inline-flex;\n  gap: 4px;\n}\n\n.admin-ranking-card__period-btn {\n  border: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n  padding: 4px 10px;\n  font-size: 11px;\n  color: var(--admin-text-secondary);\n  border-radius: var(--radius-sm, 4px);\n  cursor: pointer;\n}\n\n.admin-ranking-card__period-btn--active {\n  background: var(--primary-50, var(--admin-surface-hover));\n  border-color: var(--primary-500, var(--admin-border));\n  color: var(--primary-700, var(--admin-text-primary));\n}\n\n.admin-ranking-card__body {\n  padding: 8px 12px 12px;\n}\n\n.admin-ranking-card__empty {\n  padding: 32px;\n  text-align: center;\n  color: var(--text-tertiary, var(--admin-text-secondary));\n  font-size: 13px;\n}\n\n.admin-ranking-card__note {\n  padding: 8px 18px 10px;\n  font-size: 11px;\n  color: var(--admin-text-muted, var(--admin-text-secondary));\n}\n\n.admin-ranking-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.admin-ranking-list__item {\n  display: grid;\n  grid-template-columns: 28px 28px minmax(140px, 1.6fr) minmax(120px, 2fr) 96px;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: var(--radius-sm, 6px);\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.admin-ranking-list__item:hover {\n  background: var(--admin-surface-hover);\n}\n\n.admin-ranking-list__rank {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--admin-text-secondary);\n  background: var(--admin-surface-hover);\n}\n\n.admin-ranking-list__rank--top {\n  background: linear-gradient(135deg, #fde68a 0%, #f59e0b 100%);\n  color: #78350f;\n}\n\n.admin-ranking-list__logo {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-ranking-list__avatar {\n  background: linear-gradient(135deg, var(--primary-400, #8b5cf6) 0%, var(--primary-600, #6d28d9) 100%);\n  color: #fff;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.admin-ranking-list__info {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.admin-ranking-list__name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-ranking-list__sub {\n  font-size: 11px;\n  color: var(--admin-text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-ranking-list__bar {\n  position: relative;\n  height: 6px;\n  background: var(--admin-surface-hover);\n  border-radius: 999px;\n  overflow: hidden;\n  min-width: 80px;\n}\n\n.admin-ranking-list__bar-fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-radius: 999px;\n  background: var(--primary-500, #8b5cf6);\n  transition: width 0.25s ease;\n}\n\n.admin-ranking-list__value {\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
